import { RootState } from '../store';
import { SubscriptionPlan } from '@/constants/plans';

export const selectAuthPaymentStatus = (state: RootState) => state.auth.paymentStatus;
export const selectAuthIsTrial = (state: RootState) => state.auth.isTrial;
export const selectAuthErrorRegister = (state: RootState) => state.auth.errorRegister;
export const selectAuthErrorLogin = (state: RootState) => state.auth.errorLogin;
export const selectAuthErrorResetPassword = (state: RootState) => state.auth.errorResetPassword;
export const selectAuthSuccessResetPassword = (state: RootState) => state.auth.successResetPassword;
export const selectAuthIsRecovery = (state: RootState) => state.auth.isRecovery;

export const selectAuthLoading = (state: RootState) => state.auth.loading;
export const selectAuthStatusResetPassword = (state: RootState) => state.auth.successResetPassword;
export const selectAuthLoadingUpdate = (state: RootState) => state.auth.loadingUpdate;
export const selectAuthLoadingCompetitors = (state: RootState) => state.auth.accountRegister.loadingCompetitors;
export const selectAuthLoadingBrandRegister = (state: RootState) => state.auth.accountRegister.loadingCompetitors;
export const selectAuthUser = (state: RootState) => state.superuser.user || state.auth.user;

export const selectAuthIsSuperuser = (state: RootState) => state.auth.role === "superuser";

export const selectAuthUserID = (state: RootState) => state.superuser.user?.id || state.auth.user?.id;
/**
 * User id that owns shared data (brands, prompts, scores): account owner for team members,
 * otherwise the logged-in user. Never fall back to the member's own id when isMember — that
 * would scope rows to the wrong user.
 */
export const selectAuthAccountId = (state: RootState) => {
  if (state.superuser.supermode && state.superuser.user) {
    return state.superuser.user.id;
  }
  if (state.auth.actingAsClientId) {
    return state.auth.actingAsClientId;
  }
  if (state.auth.isMember) {
    return state.auth.accountId;
  }
  return state.auth.accountId ?? selectAuthUserID(state) ?? null;
};
/**
 * The agency's own account ID, ignoring impersonation.  Superuser override
 * still applies; `actingAsClientId` does NOT — agency management APIs must
 * always send the agency's own ID regardless of who is being impersonated.
 */
export const selectAuthOwnAccountId = (state: RootState) => {
  if (state.superuser.supermode && state.superuser.user) {
    return state.superuser.user.id;
  }
  if (state.auth.isMember) {
    return state.auth.accountId;
  }
  return state.auth.accountId ?? selectAuthUserID(state) ?? null;
};
export const selectAuthIsMember = (state: RootState) => state.auth.isMember;
export const selectAuthIsAgency = (state: RootState) => state.auth.isAgency;
export const selectAuthIsManagedClient = (state: RootState) => state.auth.isManagedClient;
export const selectAuthActingAsClientId = (state: RootState) => state.auth.actingAsClientId;
export const selectAuthActingAsLabel = (state: RootState) => state.auth.actingAsLabel;
export const selectAuthActingAsEmail = (state: RootState) => state.auth.actingAsEmail;

export const selectAuthSubscriptionPlan = (state: RootState): SubscriptionPlan | null | undefined => state.auth.subscriptionPlan as SubscriptionPlan | null | undefined;

export const selectAuthLoadingRelatedBrands = (state: RootState) => state.auth.accountRegister.loadingRelatedBrands;
export const selectAuthRelatedBrands = (state: RootState) => state.auth.accountRegister.relatedBrands;

export const selectAuthLoadingRegister = (state: RootState) => state.auth.accountRegister.loading;
export const selectAuthStepRegister = (state: RootState) => state.auth.accountRegister.step;
export const selectAuthCompany = (state: RootState) => state.auth.accountRegister.company;
export const selectAuthPlan = (state: RootState) => state.auth.accountRegister.plan;
export const selectAuthCompetitorsRegister = (state: RootState) => state.auth.accountRegister.competitors;
export const selectAuthSelectedCompetitorsRegister = (state: RootState) => state.auth.accountRegister.selectedCompetitors;

